import { Button, Dropdown, Layout, Menu, Space } from 'antd';
import Branding from '../../../ui/Branding';
import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getRoutes } from '../../../../routes/Routes';

const { Header } = Layout;

const PublicHeader = () => {
    const navigate = useNavigate();

    const items = [
        { key: 'login', label: 'Login', onClick: () => navigate(getRoutes().login.route()) },
        {
            key: 'register',
            label: 'Become a Customer',
            onClick: () => navigate(getRoutes().register.route()),
        },
    ];

    return (
        <Header className="app-header">
            <div className="container flex align-items-center justify-content-between w-full">
                <Space size="large" align="center" className="branding-container">
                    <Branding />
                </Space>

                <Dropdown
                    menu={{ items }}
                    trigger={['click']}
                    placement="bottomRight"
                    className="responsive-menu"
                >
                    <Button icon={<MenuOutlined />} />
                </Dropdown>
                <Space size="small" className="header-actions">
                    <Button
                        color="primary"
                        variant="link"
                        onClick={() => navigate(getRoutes().login.route())}
                        icon={<UserOutlined />}
                    >
                        Login
                    </Button>
                    <Button
                        color="primary"
                        variant="solid"
                        onClick={() => navigate(getRoutes().register.route())}
                    >
                        Become a Customer
                    </Button>
                </Space>
            </div>
        </Header>
    );
};

export default PublicHeader;
